import React from 'react';
import { UserRound, ShieldCheck, BellRing, CreditCard, Lock, ScrollText, Receipt, FileText } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { HostSettingsLayout } from '../../components/HostSettingsLayout';
import { HostActionRow } from '../../components/HostSettingsCard';

export default function HostSettingsPage() {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem('user') || '{}');

  const iconColor = 'var(--text)';
  const items = [
    { label: 'Personal Information', icon: <UserRound size={24} color={iconColor} strokeWidth={1.6} />, action: () => navigate('/host/settings/personal'), testId: 'host-settings-personal-button' },
    { label: 'Login & Security', icon: <ShieldCheck size={24} color={iconColor} strokeWidth={1.6} />, action: () => navigate('/host/settings/security'), testId: 'host-settings-security-button' },
    { label: 'Privacy', icon: <Lock size={24} color={iconColor} strokeWidth={1.6} />, action: () => navigate('/host/settings/privacy'), testId: 'host-settings-privacy-button' },
    { label: 'Notifications & History', icon: <BellRing size={24} color={iconColor} strokeWidth={1.6} />, action: () => navigate('/host/settings/notifications'), testId: 'host-settings-notifications-button' },
    { label: 'Payouts', icon: <CreditCard size={24} color={iconColor} strokeWidth={1.6} />, action: () => navigate('/host/settings/payouts'), testId: 'host-settings-payouts-button' },
    { label: 'VAT / Tax ID', icon: <FileText size={24} color={iconColor} strokeWidth={1.6} />, action: () => navigate('/host/settings/vat'), testId: 'host-settings-vat-button' },
    { label: 'Agreements', icon: <ScrollText size={24} color={iconColor} strokeWidth={1.6} />, action: () => navigate('/host/settings/agreements'), testId: 'host-settings-agreements-button' },
    { label: 'Earnings statements', icon: <Receipt size={24} color={iconColor} strokeWidth={1.6} />, action: () => navigate('/host/settings/invoices'), testId: 'host-settings-invoices-button' },
  ];

  return (
    <HostSettingsLayout title="Account Settings" dataTestId="host-settings-page">
      {items.map((item) => (
        <HostActionRow key={item.label} label={item.label} icon={item.icon} onClick={item.action} dataTestId={item.testId} />
      ))}
      <p data-testid="host-settings-account-id" style={{ marginTop: 26, textAlign: 'center', fontFamily: "'Inria Serif', serif", fontSize: 20, color: 'var(--text-2)' }}>
        Account ID: {user.customer_id || '—'}
      </p>
    </HostSettingsLayout>
  );
}